import { render, staticRenderFns } from "./UserStaff.vue?vue&type=template&id=624f4db0&"
import script from "./UserStaff.vue?vue&type=script&lang=js&"
export * from "./UserStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports